module.exports = __webpack_public_path__ + "static/media/ajax-Loader.50feca2b.gif";